export class DepartmentReportsTextCopy {

  public static lettersAnswered = `letters answered`;
  public static lettersChanged = `the increase/decrease in letters answered
    compared with the previous period`;
  public static lettersTotal = `the number of letters answered as a % of the dept/team total`;
  public static lettersCanc = `the number of PCNs cancelled as a % of the letters answered`;
  public static lettersBespoke = `the number of bespokes as a % of the letters answered`;
  public static lettersOverride = `the number of letters where a user has changed the Response
    Master decision as a % of the letters answered`;
  public static qualityReceived = `unwanted follow-ups received (in response to uphold letters
    from this team) as a % of letters answered`;
  public static qualityChange = `the increase/decrease in unwanted follow-ups compared with
    the previous period`;
  public static outputPp = `output rate per person per day (calculated on the basis of
    ten-minute segments worked and displayed as a letters-per-day equivalent)`;
  public static outputChange = `the increase/decrease in output rate compared with the previous period`;
  public static timeLetters = `the % of working time spent on letters`;

}
